import { http } from '~/src/services/requests';

export interface RemoteAccessRequest {
  target_id: number;
  target_email: string;
  expires_at: string;
}

interface ValidRemoteAccessRequestsResponse {
  targets: RemoteAccessRequest[];
}

function internalToolsService() {
  return {
    getValidRemoteAccessRequests:
      async (): Promise<ValidRemoteAccessRequestsResponse> => {
        const parse = true;
        return http.innerSendAuthenticated(
          {
            relativePath: '/internaltools/remote-access/valid-targets',
            method: 'GET',
          },
          parse,
        );
      },
  };
}

export default internalToolsService;
